module.exports = __webpack_public_path__ + "7ae354822a0b6edc9ffa74a794d8a279.png";